// web/src/features/home/HomeCustomize.tsx
// The editable canvas: every widget free-placed (drag/resize) in one grid.
// Grouping was removed, so this is a single WidgetGridEdit over all widgets.
import { WidgetGridEdit } from './WidgetGridEdit';
import type { HomeLayout } from './types';

export function HomeCustomize({ layout, onMove, onResizeBox, onSetSize, onRemove, onSetConfig }: {
  layout: HomeLayout;
  onMove: (id: string, x: number, y: number) => void;
  onResizeBox: (id: string, x: number, y: number, w: number, h: number) => void;
  onSetSize: (id: string, w: number) => void;
  onRemove: (id: string) => void;
  onSetConfig: (id: string, config: Record<string, unknown>) => void;
}) {
  return (
    <WidgetGridEdit widgets={layout.widgets}
      onMove={onMove} onResizeBox={onResizeBox} onSetSize={onSetSize}
      onRemove={onRemove} onSetConfig={onSetConfig}
      emptyHint="No widgets yet. Use Add widget in the top bar." />
  );
}
